import { formatCurrency2CompactNumber } from 'src/utils/number/currency'

export const diffLeaves = (oldLeaf, newLeaf) => {
  const prevPrice = formatCurrency2CompactNumber(oldLeaf.data.price)
  const nextPrice = formatCurrency2CompactNumber(newLeaf.data.price)

  if (prevPrice !== nextPrice) {
    return prevPrice > nextPrice ? -1 : 1
  }

  return 0
}

export default diffLeaves
